import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";
import sanitizeField from "../../utils/sanitizeField";

export const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    Laboratório: sanitizeField(item?.lab_name || ""),
    Projeto: sanitizeField(item?.project_name || ""),
    Ciclo: item?.order_cycle_id || "",
    "Data de criação do ciclo": item.cycle_created_at ? moment(item.cycle_created_at).format("DD/MM/YYYY") : "",
    Documento: item?.user_document || "",
    Nome: sanitizeField(item?.user_name || ""),
    Especialidades: item.user_specialties
      ? item.user_specialties.filter(specialty => specialty).join(" / ")
      : "",
    Nota: item?.order_rate || "",
    Comentário: sanitizeField(item?.rate_value || ""),
    "Data da avaliação": item.rate_created_at ? moment(item.rate_created_at).format("DD/MM/YYYY") : "",
    Amostra: sanitizeField(item?.sample_name || ""),
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: [
        "Laboratório",
        "Projeto",
        "Ciclo",
        "Data de criação do ciclo",
        "Documento",
        "Nome",
        "Especialidades",
        "Nota",
        "Comentário",
        "Data da avaliação",
        "Amostra",
      ],
    },
    {
      delimiter: ";",
      quotes: true,
      quoteChar: '"',
      encoding: "utf-8",
    }
  );

  downloadCsv(csv, "reviews");
};